import React, { Component } from 'react';
import _ from 'lodash';

import Icon from '../../../../../../components/Icon';

import './styles.css';

export default class SelectField extends Component {
  constructor() {
    super();
    this.state = {
      dropdownActive: false,
    };
  }

  _selectItem = (item) => {
    this.props.selected = item;
  }

  render() {
    const { options } = this.props;
    return (
      <div className="SelectField">
        <div className={`SelectField__select ${this.props.disabled ? 'SelectField__select--disabled' : ''}`} onClick={() => { if (!this.props.disabled) this.setState({ dropdownActive: !this.state.dropdownActive }); }}>
          <span>{!_.isEmpty(this.props.selected) ? this.props.selected.name : 'Selecione...'}</span>
          <Icon
            name={this.state.dropdownActive ? 'arrow_drop_up' : 'arrow_drop_down'}
            className="SelectField__icon"
          />
        </div>
        {this.state.dropdownActive &&
          <ul className="SelectField__dropdown-list">
            {
              options.map(item => (
                <li
                  key={item.id}
                  className="SelectField__dropdown-list-item"
                  onClick={() => { this.props.onSelected(item, this.props.type); this.setState({ dropdownActive: !this.state.dropdownActive, selected: item }); }}
                >
                  <div>
                    <span className="SelectField__dropdown-list-item-label">
                      {item.name}
                    </span>
                  </div>
                </li>
              ))
            }
          </ul>
        }
      </div>
    );
  }
}

